import { defineFcm } from '../shared/factory';

export const FCM_GROWTH_MEMBERSHIP_ROUTING_UPDATE = defineFcm('growth_membership_routing_update')
	.asBoolean()
	.withDefault(false)
	.toConfig();
